<template>
  <div class="whole">
    <m-header></m-header>
    <m-sidebar></m-sidebar>
    <div class="data-content">
      <!--      <div style="margin: 20px;">-->
      <!--        <el-radio-group v-model="status" @current-change="handleChange()" size="small">-->
      <!--          <el-radio-button label="1">商城分类管理</el-radio-button>-->
      <!--          <el-radio-button label="2">门店分类管理</el-radio-button>-->
      <!--        </el-radio-group>-->
      <!--      </div>-->
      <div class="categoryOperate">
        <el-button @click="handleAdd" type="primary" size="small"
          >新增分类</el-button
        >
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page="pageNum"
          @current-change="pageChange"
          :total="totalNum"
          v-if="paginationShow"
        >
        </el-pagination>
      </div>
      <div class="categoryTable">
        <el-table
          ref="multipleTable"
          :data="categoryDatas"
          tooltip-effect="dark"
          style="width: 100%"
          border
        >
          <el-table-column prop="id" label="序号" width="60"> </el-table-column>
          <el-table-column prop="name" label="分类名称" width="160">
          </el-table-column>
          <el-table-column
            prop="categoryVos"
            label="子分类"
            width="400"
            align="left"
          >
            <!-- 分行显示 -->
            <template slot-scope="scope">
              <el-tag
                :key="index"
                v-for="(item, index) in scope.row.categoryVos"
                closable
                :disable-transitions="false"
                @close="handleClose(item)"
              >
                {{ item.name }}
              </el-tag>
              <!-- <e v-for="(item,index) in scope.row.categoryVos" :key="index">
            {{item.name}}
            </div> -->
            </template>
          </el-table-column>
          <el-table-column prop="insertTime" label="创建时间" width="180">
          </el-table-column>
          <!-- 在 .el-table-column[label="操作"] 上应用了 show-overflow-tooltip 属性，当列内容超出可视区域时，它会被裁剪并显示为省略号（...）。
用户可以通过悬停在省略号上来查看被截断的内容，通常是以工具提示（tooltip）的形式展示。 -->
          <!-- <el-table-column label="操作" show-overflow-tooltip> -->
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="handleAddChild(scope.$index, scope.row)"
                >添加子类</el-button
              >
              <el-button
                size="mini"
                @click="handleEdit(scope.$index, scope.row)"
                >编辑</el-button
              >
              <el-button
                size="mini"
                @click="handleSonEdit(scope.$index, scope.row)"
                >编辑子分类</el-button
              >
              <el-button
                size="mini"
                type="danger"
                @click="handleDelete(scope.$index, scope.row)"
                >删除分类</el-button
              >
              <!-- 新加的是否进入商城 -->
              <el-button
                size="mini"
                :class="getButtonClass(scope.row)"
                @click="handleOpenClose(scope.$index, scope.row)"
                >{{ getStatusText(scope.row) }}
              </el-button>
              <!-- 新加的是否进入首页商城 -->
              <el-button
                size="mini"
                :class="getButtonShouClass(scope.row)"
                @click="handleShouOpenClose(scope.$index, scope.row)"
                >{{ getShouStatusText(scope.row) }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-dialog
        title="修改分类"
        :visible.sync="editDialogVisible"
        :append-to-body="true"
        width="40%"
        :modal="false"
      >
        <el-form label-position="left" label-width="80px" :model="controlData">
          <el-form-item label="名称:">
            <el-input v-model="controlData.name"></el-input>
          </el-form-item>
          <el-form-item label="分类图片">
            <el-upload
              action=""
              class="upload-demo"
              :http-request="uploadSectionFile"
              :limit="1"
              :file-list="fileList"
              list-type="picture"
            >
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="editDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="_updateCategory()">确 定</el-button>
        </div>
      </el-dialog>
      <!-- 新加的修改子分类的弹窗 -->
      <!-- 在弹窗内的相关输入框组件中添加 disabled 属性。这将阻止用户编辑该字段的内容。 -->
      <el-dialog
        title="修改子分类"
        :visible.sync="editDialogSonVisible"
        :append-to-body="true"
        width="40%"
        :modal="false"
      >
        <el-form label-position="left" label-width="90px" :model="controlData">
          <el-form-item label="父类名称:">
            <el-input v-model="controlData.name" disabled></el-input>
          </el-form-item>
          <!-- 新增的子分类选择下拉框 -->
          <el-form-item label="选择子分类:">
            <el-select
              v-model="selectedChildData.id"
              placeholder="请选择子分类"
              @change="updateControlDataForSelectedChild"
            >
              <el-option
                v-for="item in currentCategoryChildren"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="排序:">
            <el-input
              v-model="selectedChildData.sort"
              placeholder="请输入数字，数字越大排序越往后"
            ></el-input>
          </el-form-item>
          <el-form-item label="子分类图片">
            <el-upload
              action=""
              class="upload-demo"
              :http-request="uploadSonSectionFile"
              :limit="1"
              :file-list="fileList"
              list-type="picture"
            >
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="editDialogSonVisible = false">取 消</el-button>
          <el-button type="primary" @click="_updateSonCategory()"
            >确 定</el-button
          >
        </div>
      </el-dialog>
      <el-dialog
        title="添加子分类"
        :visible.sync="addDialogVisible"
        :append-to-body="true"
        width="30%"
        :modal="false"
      >
        <el-form label-position="left" label-width="80px" :model="controlData">
          <el-form-item label="父级分类:" v-if="controlData.parent">
            <el-input :disabled="true" v-model="controlData.parent"></el-input>
          </el-form-item>
          <el-form-item label="分类名称:">
            <el-input v-model="controlData.name"></el-input>
          </el-form-item>
          <el-form-item label="排序:">
            <el-input
              v-model="controlData.sort"
              placeholder="请输入数字，数字越大排序越往后"
            ></el-input>
          </el-form-item>
          <el-form-item label="分类图片">
            <el-upload
              action=""
              class="upload-demo"
              :http-request="uploadSectionFile"
              :limit="1"
              :file-list="fileList"
              list-type="picture"
            >
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="addDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="_addCategory()">确 定</el-button>
        </div>
      </el-dialog>
      <el-dialog
        title="提示"
        :visible.sync="deleteDialogVisible"
        width="20%"
        :append-to-body="true"
        center
      >
        <span>确定要删除当前一级分类吗？</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="deleteDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="_deleteCategory()">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { Loading } from "element-ui";
import MSidebar from "components/header/sidebar";
import MHeader from "components/header/header";
import {
  getAllCategory, //得到所有的分类
  addCategory,
  updateCategory,
  deleteCategory,
  uploadFile1,
  postSuperOpenClose, //开启关闭进入商场的接口
  postShouSuperOpenClose //开启关闭进入首页商城的接口
} from "api/request";
import { getDepartment } from "api/post";
import { ERR_OK } from "api/config";
import { formatDate, loadingInstance, Success, Error } from "common/js/util";

export default {
  components: { MSidebar, MHeader },
  data() {
    return {
      currentCategoryChildren: [], // 当前父分类下的所有子分类
      selectedChildData: {}, // 新增用于存储选中子分类的数据
      editingSubcategoryId: null, // 用于存储正在编辑的子分类ID
      imageUrl: null,
      fileList: [],
      status: 1,
      pageSize: 10,
      pageNum: 1,
      totalPage: 0,
      keywords: null,
      paginationShow: false,
      detailDialogVisible: false,
      pushDialogVisible: false,
      editDialogVisible: false, //修改分类的弹窗
      editDialogSonVisible: false, //修改子分类的弹窗
      addDialogVisible: false,
      freezeDialogVisible: false,
      deleteDialogVisible: false,
      controlData: {},
      userDetail: [],
      categoryDatas: [],
      cfAdminVos: []
    };
  },
  mounted() {
    let getUserInfo = JSON.parse(window.localStorage.getItem("getUserInfo"));
    if (!getUserInfo) {
      this.$router.push({
        path: "/"
      });
    } else {
      this._getList();
    }
  },
  watch: {
    "controlData.selectedChild"(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.updateControlDataForSelectedChild();
      }
    }
  },
  methods: {
    // 确定进入商城按钮类的方法
    getButtonClass(row) {
      if (row.isSupermarket == "1") {
        // return ""; // 默认类或无类
        return "red-button"; // 使按钮变红的类
      } else if (row.isSupermarket == "0" || row.isSupermarket == null) {
        // return "red-button"; // 使按钮变红的类
        return ""; // 默认类或无类
      }
    },
    // 确定进入首页商城按钮类的方法
    getButtonShouClass(row) {
      if (row.isNewSupermarket == "1") {
        return "red-button"; //使按钮变成红色的类
      } else if (row.isNewSupermarket == "0" || row.isNewSupermarket == null) {
        return "";
      }
    },
    // 开启进入商城，  这个页面记得引入一个接口postSuperOpenClose（类似于这个，等待后端给接口）
    handleOpenClose(index, row) {
      var isSupermarket;
      if (row.isSupermarket == "1") isSupermarket = "0";
      if (row.isSupermarket == "0" || row.isSupermarket == null)
        isSupermarket = "1";
      let param = {
        id: row.id,
        isSupermarket: isSupermarket
      };
      loadingInstance(Loading);
      postSuperOpenClose(param).then(res => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this._getList();
        } else {
          Error(this, res);
        }
      });
    },
    // 是否进入首页商城 这个页面记得引入一个接口postShouSuperOpenClose（类似于这个，等待后端给接口）
    handleShouOpenClose(index, row) {
      var isNewSupermarket;
      if (row.isNewSupermarket == "1") isNewSupermarket = "0";
      if (row.isNewSupermarket == "0" || row.isNewSupermarket == null)
        isNewSupermarket = "1";
      let param = {
        id: row.id,
        isNewSupermarket: isNewSupermarket
      };
      loadingInstance(Loading);
      postShouSuperOpenClose(param).then(res => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this._getList();
        } else {
          Error(this, res);
        }
      });
    },
    // 是否进入商城
    getStatusText(row) {
      if (row.isSupermarket == "1") return "关闭进入商城";
      if (row.isSupermarket == "0" || row.isSupermarket == null)
        return "开启进入商城";
      return "";
    },
    //是否进入首页商城
    getShouStatusText(row) {
      if (row.isNewSupermarket == "1") return "关闭进入首页商城";
      if (row.isNewSupermarket == "0" || row.isNewSupermarket == null)
        return "开启进入首页商城";
      return "";
    },
    handleClose(item) {
      this.deleteDialogVisible = true;
      this.controlData = item;
    },
    //文件类型   101 商品图片 102 供应商营业执照  103 banner图    104商品分类logo
    uploadSectionFile(param) {
      var fileObj = param.file;
      var form = new FormData();
      form.append("file", fileObj);
      form.append("type", 104);
      uploadFile1(form).then(res => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this.controlData.logo = res.data;
        } else {
          Error(this, res);
        }
      });
    },
    // 修改子分类的图片上传接口
    uploadSonSectionFile(param) {
      var fileObj = param.file;
      var form = new FormData();
      form.append("file", fileObj);
      form.append("type", 104);

      uploadFile1(form).then(res => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          // 更新 selectedChildData 的 logo
          this.selectedChildData.logo = res.data;
          // // 更新 fileList 以显示新图片
          // this.fileList = [{ name: res.data, url: res.data }];
        } else {
          Error(this, res);
        }
      });
    },
    handleChange() {
      // console.log(this.status);
    },
    pageChange(val) {
      // console.log(val);
      this.pageNum = val;
      this.categoryDatas = [];
      this._getList();
    },
    // 新增父分类
    handleAdd() {
      this.addDialogVisible = true;
      this.controlData = {};
      this.controlData.parentId = 0;
      this.controlData.logo = "";
    },
    // 添加子分类
    // handleAddChild(index, row) {
    //   this.addDialogVisible = true;
    //   this.controlData = {};
    //   this.controlData.parent = row.name;
    //   this.controlData.parentId = row.id;
    //   this.controlData.logo = "";
    // },
    handleAddChild(index, row) {
      this.addDialogVisible = true;
      // 重置 controlData 为初始状态
      this.controlData = {
        parent: row.name,
        parentId: row.id,
        logo: ""
      };
      // 重置 selectedChildData 和 fileList
      this.selectedChildData = {};
      this.fileList = [];
    },
    handleDelete(index, row) {
      this.deleteDialogVisible = true;
      this.controlData = this.categoryDatas[index];
    },
    // 修改分类
    handleEdit(index, row) {
      this.editDialogVisible = true;
      this.controlData = this.categoryDatas[index];
      this.fileList = [];
      this.fileList.push({
        name: this.controlData.logo,
        url: this.controlData.logo
      });
      this.fileList.push();
    },
    // 修改子分类
    // handleSonEdit(index, row) {
    //   this.currentCategoryChildren = row.categoryVos; // 分配子分类
    //   this.controlData = { name: row.name, parentId: row.id }; // 设置父分类名称和ID
    //   this.editingSubcategoryId = null; // 重置正在编辑的子分类ID
    //   this.editDialogSonVisible = true;
    //   if (this.currentCategoryChildren.length > 0) {
    //     this.selectedChildData = { ...this.currentCategoryChildren[0] };
    //     this.editingSubcategoryId = this.selectedChildData.id; // 设置默认子分类ID
    //   }
    // },
    handleSonEdit(index, row) {
      this.currentCategoryChildren = row.categoryVos;
      this.controlData = { name: row.name, parentId: row.id };
      if (this.currentCategoryChildren.length > 0) {
        // 假设您想编辑第一个子分类
        let firstChild = this.currentCategoryChildren[0];
        this.selectedChildData = { ...firstChild };
        this.editingSubcategoryId = firstChild.id;

        // 设置 fileList 以显示当前子分类的图片
        this.fileList = firstChild.logo
          ? [{ name: firstChild.logo, url: firstChild.logo }]
          : [];
      }
      this.editDialogSonVisible = true;
    },
    // 根据选中的子分类更新 controlData 的方法
    updateControlDataForSelectedChild() {
      const selectedChild = this.currentCategoryChildren.find(
        child => child.id === this.selectedChildData.id
      );

      if (selectedChild) {
        this.selectedChildData = { ...selectedChild };
        this.editingSubcategoryId = selectedChild.id;

        // 更新fileList以显示选中子分类的图片
        this.fileList = [];
        if (selectedChild.logo) {
          this.fileList.push({
            name: selectedChild.logo,
            url: selectedChild.logo
          });
        }
      }
    },
    handleShowDetail(row) {
      this.detailDialogVisible = true;
      this.userDetail = [row];
    },
    handleShowPush(row) {
      this.cfAdminVos = row.cfAdminVos;
      this.pushDialogVisible = true;
    },
    // 添加子分类
    _addCategory() {
      let param = {
        name: this.controlData.name,
        parentId: this.controlData.parentId,
        logo: this.controlData.logo,
        sort: this.controlData.sort
      };
      loadingInstance(Loading);
      addCategory(param).then(res => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this.addDialogVisible = false;
          this.fileList = [];
          this._getList();
        } else {
          Error(this, res);
        }
      });
    },
    // 修改分类
    _updateCategory() {
      let logoToSend;
      if (this.controlData.logo) {
        if (this.controlData.logo.includes("https://qy-static.umeng.top/")) {
          // 如果logo包含完整的URL，提取相对路径
          logoToSend = this.controlData.logo
            .split("https://qy-static.umeng.top/")
            .pop();
        } else {
          // 如果logo已经是相对路径或者是新上传的图片
          logoToSend = this.controlData.logo;
        }
      }

      let param = {
        id: this.controlData.id,
        name: this.controlData.name,
        parentId: this.controlData.parentId,
        logo: logoToSend
      };
      loadingInstance(Loading);
      updateCategory(param).then(res => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this.editDialogVisible = false;
          this._getList();
        } else {
          Error(this, res);
        }
      });
    },
    // 修改子分类
    _updateSonCategory() {
      let logoToSend;
      if (this.selectedChildData.logo) {
        if (
          this.selectedChildData.logo.includes("https://qy-static.umeng.top/")
        ) {
          // 如果logo包含完整的URL，提取相对路径
          logoToSend = this.selectedChildData.logo
            .split("https://qy-static.umeng.top/")
            .pop();
        } else {
          // 如果logo已经是相对路径或者是新上传的图片
          logoToSend = this.selectedChildData.logo;
        }
      }
      let param = {
        id: this.editingSubcategoryId, // 正在编辑的子分类ID
        name: this.selectedChildData.name, // 子分类的名称
        parentId: this.controlData.parentId, // 父分类ID
        logo: logoToSend, // 子分类的图片
        sort: this.selectedChildData.sort
      };
      loadingInstance(Loading);
      updateCategory(param).then(res => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this.editDialogSonVisible = false;
          this._getList();
        } else {
          Error(this, res);
        }
      });
    },
    _deleteCategory() {
      let param = {
        id: this.controlData.id
      };
      loadingInstance(Loading);
      deleteCategory(param).then(res => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this.deleteDialogVisible = false;
          this._getList();
        } else {
          Error(this, res);
        }
      });
    },
    // 页面列表 ，调取得到所有分类的接口getAllCategory
    _getList() {
      let param = {
        keywords: this.keywords,
        current: this.pageNum,
        size: this.pageSize
      };
      loadingInstance(Loading);
      getAllCategory(param).then(res => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this.categoryDatas = res.data.records;
          // console.log("9999");
          // console.log(this.categoryDatas);
          this.totalNum = res.data.total;
          if (res.data.pages > 1) {
            this.paginationShow = true;
          }
        } else {
          Error(this, res);
        }
      });
    }
  }
};
</script>
<style scoped>
.categoryOperate {
  height: 40px;
  margin: 20px;
  box-sizing: border-box;
}
.categoryTable {
  padding-left: 20px;
  padding-right: 20px;
  position: relative;
  /* overflow-x: auto; */
}
</style>
<style>
.el-tag + .el-tag {
  margin: 5px;
}
.categoryOperate .el-input {
  width: 180px;
  height: 40px;
  margin-right: 10px;
  display: inline-block;
  float: left;
}
.categoryOperate .el-button {
  width: 100px;
  height: 40px;
  display: inline-block;
  float: left;
  margin-right: 40px;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 150px;
  text-align: center;
}
.avatar {
  width: 150px;
  height: 150px;
  display: block;
}
/* 商城的按钮的动态类名的设置 */
.red-button {
  background-color: rgb(249, 112, 112);
  color: white; /* 可选：如有需要可更改文本颜色 */
  /* 根据需要添加其他样式 */
}
</style>



// WEBPACK FOOTER //
// src/components/product/category.vue